var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-navbar',{attrs:{"type":"light","variant":"light"}},[_c('b-container',[_c('b-navbar-brand',[_vm._v(_vm._s(_vm.t("Title")))]),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('language-selector')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }